import FormaPagamento from './FormaPagamento';

export default FormaPagamento;